import { FormItem } from "../../../../base-data/area-building/model/form-item-interface";

// 标单顶部信息
export const BID_FORM_CONTENT: FormItem[] = [
  { text: 'BidCreat.CustomerName', value: "customerName"},
  { text: 'BidCreat.BuyerName', value: "purchasingContact"},
  { text: 'BidCreat.BuyerTel', value: "purchasingTel"},
  { text: 'BidCreat.Demander', value: "demander"},
  { text: 'BidCreat.DemanderTel', value: "demanderTel"},
  { text: 'BidCreat.EngineeringName', value: "projectName"},
  { text: 'BidCreat.RFQNo', value: "inquiryNo" },

  { text: 'BidCreat.QuotationCompany', value: "quoteCompany"},
  { text: 'BidCreat.CompanyAddress', value: "companyAddress"},
  { text: 'BidCreat.BidderTel', value: "quoteTel"},
  { text: 'BidCreat.Mail', value: "email"},
  { text: 'BidCreat.QuotationDate', value: "quoteTime"},
  { text: 'BidCreat.QuotationNo', value: "quoteNo"},
  { text: 'BidCreat.PlanSource', value: "projectOrigin" },

  { text: 'BidCreat.PlanReview', value: "projectReviewer"},
];
